export * from './text';

//# sourceMappingURL=index.js.map